<template>
	<div class="id">
		<div class="bgc"></div>
		<van-swipe :loop="true" :autoplay="3000">
			<van-swipe-item v-for="(v,key) in basicData.banner" :key="key">
				<van-image :src="v" width="100%" height="160px" radius="5px">
				</van-image>
			</van-swipe-item>
		</van-swipe>
		<van-notice-bar left-icon="volume-o" :text="basicData.notice" />

		<div style="padding-top: 20px ;">
			<div class="task">
				<div style="display: flex;align-items: center;">
					<div class="sub"></div>
					<div style="font-size: 16px;"> {{$t("other.top_10")}}</div>
				</div>
				<div class="subT">
					<div style="padding-right: 4px;" @click="$router.push('/Choose')">{{$t("other.more")}}</div>
					<van-icon name="arrow" color='#979799' />
				</div>
			</div>
			<div class="vote">
				<div class="gdgride" v-for="(item, index) in basicData.lotteryList" :key="index">
					<!-- @click="$router.push({path:'/Chooses',query: {id:item.id}})" -->
					<van-image :src="item.image" fit="cover" 
						class="vanImage">
						<template v-slot:loading>
							<van-loading type="circular" />
						</template>
					</van-image>
					<div class="movieBottom">
						{{item.name}}
					</div>
				</div>
			</div>
		</div>

		<div style="padding-top:20px">
			<div class="task">
				<div style="display: flex;align-items: center;">
					<div class="sub"></div>
					<div style="font-size: 16px;">{{$t("other.most_popular")}}</div>
				</div>
				<div class="subT">
					<div style="padding-right: 4px;" @click="$router.push('/video')">{{$t("other.more")}}</div>
					<van-icon name="arrow" color='#979799' />
				</div>
			</div>
			<div class="most">
				<div class="gdgride" v-for="(item, index) in basicData.filmHot" :key="index">
					<van-image :src="item.image" @click="toDetail(item.id)" class="van-image"  fit="cover">
						<template v-slot:loading>
							<div class="placeholder"></div>
						</template>
					</van-image>
					<van-image :src="require(`@/img/home/no${index+1}.png`)" width="50" height="50" class="image"  fit="cover"/>
					<div class="movie-bottom">
						<div class="movie-time-div">
							<span>{{item.title}}</span>
							<span style="font-size: 12px;">
								{{item.duration}}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div style="padding-top:20px">
			<div class="task">
				<div style="display: flex;align-items: center;">
					<div class="sub"></div>
					<div style="font-size: 16px;"> {{$t("other.more")}}</div>
				</div>
				<div class="subT">
					<div style="padding-right: 4px;" @click="$router.push('/video')">{{$t("other.more")}}</div>
					<van-icon name="arrow" color='#979799' />
				</div>
			</div>
			<div class="more">
				<div class="gdgride" v-for="(item, index) in basicData.filmList" :key="index">
					<van-image :src="item.image" @click="toPlayVideo(item.id)" class="imageT" fit="cover"/>
					<div class="bottomBg">
						{{$t("play")}}：{{item.views}}
					</div>
				</div>
			</div>
		</div>
		<div style="padding-bottom: 55px;"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				basicData: {},
				groupedData: [{
					img_url: ''
				}],
			};
		},
		mounted() {},
		created() {
			this.getBasicConfig();
			// this.getxuanfeilist();
		},
		methods: {
			getBasicConfig() {
				this.$http({
					method: "get",
					url: "getData",
				}).then((res) => {
					this.basicData = res.data;
					console.log(this.basicData, '111');
				});
			},

			toLogin(str) {
				this.$router.push({
					path: str
				});
			},

			toDetail(id) {
				this.$router.push({
					path: "/PlayVideo",
					query: {
						id
					}
				});
			},
			// 查看视频
			toPlayVideo(id) {
				this.$router.push({
					path: "/PlayVideo",
					query: {
						id
					}
				});
			},
			getxuanfeilist() {
				this.$http({
					method: "get",
					url: "xuanfeilist",
					data: {
						id: 1,
						page: 1
					},
				}).then((res) => {
					this.groupedData = res.data
					console.log(res.data, 'res.data');
				});
			},
		},


	};
</script>

<style lang="less" scoped>
	::v-deep .van-notice-bar {
		font-size: 30px !important;
		margin-top: 20px;
		height: 80px !important;
		border-radius: 10px;
	}

	::v-deep .van-notice-bar__left-icon,
	.van-notice-bar__right-icon {
		font-size: 30px !important;
	}

	.placeholder {
		width: 100%;
		height: 200px;
		background-color: #f7f8fa;
		/* 浅灰色背景 */
	}

	.id {
		padding: 30px;
		min-height: 100vh;
		background-color: #f2f2f5;
		position: relative;
	}

	.vanSwipe {}

	.bgc {
		position: absolute;
		top: 0;
		left: 0;
		height: 26.667vw;
		background: linear-gradient(270deg, #e6c3a1, #f905e5);
		width: 100%;
		z-index: 0;
	}

	.task {
		display: flex;
		align-items: center;
		justify-content: space-between;

		.subT {
			display: flex;
			align-items: center;
			color: #979799;
			font-size: 28px;
		}

		.sub {
			width: 1vw;
			height: 4vw;
			background-color: #f905e5;
			border-radius: 1px;
			margin-right: 16px;
		}
	}

	.vote {
		display: flex;
		overflow-y: auto;
		padding: 20px 0;
		scrollbar-width: none;
		-ms-overflow-style: none;

		.gdgride {
			margin-right: 50px;
			display: flex;
			flex-direction: column;
			align-items: center;
			border-radius: 10px;

			.vanImage {
				width: 140px;
				height: 140px;
				border-radius: 8px;
				object-fit: cover;
			}

			.movieBottom {
				font-size: 26px;
				padding-top: 20px;
			}
		}
	}

	.more {
		display: flex;
		padding: 20px 0;
		flex-wrap: wrap;
		justify-content: space-between;

		.gdgride {
			position: relative;
			width: 48%;
			margin-bottom: 30px;

			.imageT {
				width: 100%;
				height: 240px;
			}


			.bottomBg {
				position: absolute;
				width: 100%;
				bottom: 8px;
				background-color: rgba(0, 0, 0, 0.4);
				color: #fff;
				border-radius: 0 0 10px 10px;
				padding: 0px 10px;
				height: 8vw;
				display: flex;
				align-items: center;
				justify-content: flex-end;
				font-size: 28px;
			}
		}
	}

	.most {
		display: flex;
		overflow-y: auto;
		padding: 20px 0;
		scrollbar-width: none;
		-ms-overflow-style: none;

		.gdgride {
			margin-right: 10px;
			position: relative;

			.van-image {
				width: 500px;
				height: 300px;
				border-radius: 8px;
				object-fit: cover;
			}

			.image {
				position: absolute;
				top: 0;
				left: 0;
				width: 80px;
				object-fit: cover;
			}

			.movie-bottom {
				position: absolute;
				width: 100%;
				bottom: 0;

				.movie-time-div {
					background-color: rgba(0, 0, 0, 0.4);
					color: #fff;
					border-radius: 0 0 10px 10px;
					padding: 0px 10px;
					height: 8vw;
					display: flex;
					align-items: center;
					justify-content: space-between;

					span:first-child {
						overflow: hidden;
						white-space: nowrap;
						width: 24vw;
						padding-left: 16px;
						font-size: 3vw;
					}
				}
			}
		}
	}
</style>